<template>
    <section class="chart-container">
        <el-upload
                :http-request="Upload"
                :data="dataObj"
                :multiple="false"
                :show-file-list="false"
                :before-upload="beforeUpload"
        class="image-uploader"
        drag
        action=""
        >
        <i class="el-icon-upload"/>
          <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <el-progress :text-inside="true" :stroke-width="20" :percentage="progress" status="exception" ></el-progress>
        <img :src="tempUrl"/>

        <input type="file" accept="image/png,image/jpeg"   @change="uploadInput"/>
    </section>
</template>

<script>
    import echarts from 'echarts'
    import OSS from 'ali-oss'
    import {client} from '../../assets/js/ali-oss-util'

    export default {
        data() {
            return {
                dataObj:{},
                name:'/image/',
                tempUrl:'',
                progress:0,
            }
        },

        methods: {
            beforeUpload() {

            },
            uploadInput(e){
                let fileBean=e.target.files[ 0 ];
                fileBean.uid=e.target.files[ 0 ].lastModified;
                let file={
                    file:fileBean
                }
                this.Upload(file);
            },
            Upload(file) {
                const self = this
                //判断扩展名
                const tmpcnt = file.file.name.lastIndexOf(".")
                const exname = file.file.name.substring(tmpcnt + 1)
                const names = ['jpg', 'jpeg', 'webp', 'png', 'bmp','mp4']
                if (names.indexOf(exname) < 0) {
                    this.$message.error("不支持的格式!")
                    return
                }

                async function multipartUpload() {

                    const fileName = self.name + file.file.uid+"."+exname;
                    console.log("fileName",fileName);
                    //定义唯一的文件名，打印出来的uid其实就是时间戳
                    //client 是第一步中的 client
                    client().put(fileName, file.file,
                        {
                            progress: function (p) { //获取进度条的值
                                console.log(p)
                                self.progress = p * 100
                            },

                        }).then(
                        result => {
                            //下面是如果对返回结果再进行处理，根据项目需要
                             console.log(result.res.requestUrls[0]);
                             console.log(result);
                         //   self.tempUrl =result.res.requestUrls[0];
                            self.tempUrl =result.url;

                        }).catch(err => {
                        console.log("err:", err)
                    })
                }

                multipartUpload()


            },
        },
        mounted: function () {
         //   this.drawCharts()
        },
        updated: function () {

        }
    }
</script>

<style scoped>
    .chart-container {
        width: 100%;
        float: left;
    }
    /*.chart div {
        height: 400px;
        float: left;
    }*/

    .el-col {
        padding: 30px 20px;
    }
</style>



// WEBPACK FOOTER //
// test.vue?2a0c3af6